import { useProjectAudit, ACTION_LABELS, ENTITY_LABELS } from '../lib/audit';
import { formatDateTime } from '../lib/format';

interface ProjectAuditPanelProps {
  projectId: number;
}

export function ProjectAuditPanel({ projectId }: ProjectAuditPanelProps) {
  const audit = useProjectAudit(projectId, 10);

  if (audit.isLoading) return null;
  const items = audit.data?.items ?? [];
  if (items.length === 0) return null;

  return (
    <div className="card" style={{ marginTop: 20 }}>
      <div className="card-title">Letzte Änderungen</div>
      <div>
        {items.map((a) => (
          <div className="audit-item" key={a.id} style={{ display: 'flex', gap: 14, padding: '10px 0', borderBottom: '1px solid var(--color-divider)' }}>
            <div className="audit-dot" style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-primary)', flexShrink: 0, marginTop: 5 }} />
            <div className="audit-time" style={{ fontSize: 11, color: 'var(--color-text-soft)', whiteSpace: 'nowrap', minWidth: 120 }}>
              {formatDateTime(a.created_at)}
            </div>
            <div className="audit-text" style={{ fontSize: 13, color: 'var(--color-text-strong)' }}>
              <span style={{ fontWeight: 600 }}>{a.user_name ?? 'System'}</span>
              {' '}
              <span style={{ color: 'var(--color-text-soft)' }}>
                {ACTION_LABELS[a.action].toLowerCase()} {ENTITY_LABELS[a.entity_type]} #{a.entity_id}
                {a.field_name ? ` · ${a.field_name}` : ''}
              </span>
              {a.field_name && a.action === 'UPDATE' && (
                <div style={{ fontSize: 11, color: 'var(--color-text-soft)', marginTop: 2 }}>
                  <span style={{ textDecoration: 'line-through' }}>{a.old_value ?? '—'}</span>
                  {' → '}
                  <span style={{ color: 'var(--color-text-strong)', fontWeight: 600 }}>{a.new_value ?? '—'}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
